module.exports = __webpack_public_path__ + "img/Employee.5fe73180.svg";